import React from 'react'

import { makeAppStyles, useAppTheme } from '@percept/mui'


const useStyles = makeAppStyles( theme => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '20vh',
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
  },
  logo: {
    display: 'flex',
    marginBottom: theme.spacing(6),
  },
}))


export const OAuthLayout = ({
  children,
}: React.PropsWithChildren<{}>): JSX.Element => {
  const classes = useStyles()
  const appTheme = useAppTheme()
  const { LogoComponent } = appTheme.branding
  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <LogoComponent
          size={24}
          units='px'
          color={appTheme.palette.primary.main}
          opacity={1} />
      </div>
      {children}
    </div>
  )
}


export default OAuthLayout
